import { render, staticRenderFns } from "./loadingView.vue?vue&type=template&id=55cefde4&scoped=true"
import script from "./loadingView.vue?vue&type=script&lang=js"
export * from "./loadingView.vue?vue&type=script&lang=js"
import style0 from "./loadingView.vue?vue&type=style&index=0&id=55cefde4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cefde4",
  null
  
)

export default component.exports